import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

import { computed, inject } from "vue";
import { ENABLED_FEATURES } from "@/util";
import { appStore, cyStore, permissionStore } from "@/hooks";
import { FlexBox, IconButton, Separator } from "@/components/common";
import { NodeDisplay } from "@/components/graph/display";


/**
 * Renders a context menu for the tim tree.
 */
const __default__ = {
  name: "TimMenu",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const handleCloseMenu = inject<() => void>("menu-close");

const drawMode = computed(() => appStore.popups.drawTrace);

const displayActions = computed(() =>
  permissionStore.isAllowed("project.edit_data")
);
const displayGenerateActions = computed(() =>
  permissionStore.isAllowed("project.generate")
);

/**
 * Handles a menu action and closes the menu.
 * @param action - The action to handle.
 */
function handleAction(action: () => void): void {
  action();
  handleCloseMenu?.();
}

return (_ctx: any,_cache: any) => {
  return (displayActions.value)
    ? (_openBlock(), _createBlock(_unref(NodeDisplay), {
        key: 0,
        color: "neutral",
        variant: "menu",
        onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
        onMouseup: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(FlexBox), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IconButton), {
                icon: drawMode.value ? 'cancel' : 'trace',
                tooltip: 
          drawMode.value ? 'Cancel draw mode' : 'Draw artifact type direction'
        ,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleAction(() => _unref(cyStore).drawMode('toggle'))))
              }, null, 8, ["icon", "tooltip"]),
              (displayGenerateActions.value)
                ? (_openBlock(), _createBlock(_unref(Separator), {
                    key: 0,
                    class: "q-mx-xs",
                    vertical: ""
                  }))
                : _createCommentVNode("", true),
              (displayGenerateActions.value && _unref(ENABLED_FEATURES).GENERATE_SUMMARIES)
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 1,
                    color: "gradient",
                    "data-cy": "button-summarize-artifact",
                    icon: "generate-summaries",
                    tooltip: "Summarize artifacts",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (
          handleAction(() => _unref(appStore).openDetailsPanel('summarizeArtifact'))
        ))
                  }))
                : _createCommentVNode("", true),
              (displayGenerateActions.value)
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 2,
                    color: "gradient",
                    icon: "generate-artifacts",
                    tooltip: "Generate artifacts",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (
          handleAction(() => _unref(appStore).openDetailsPanel('generateArtifact'))
        ))
                  }))
                : _createCommentVNode("", true),
              (displayGenerateActions.value)
                ? (_openBlock(), _createBlock(_unref(IconButton), {
                    key: 3,
                    color: "gradient",
                    icon: "generate-traces",
                    tooltip: "Generate trace links",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (handleAction(() => _unref(appStore).openDetailsPanel('generateTrace'))))
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})